const state = {
  informationalCards: {
    mortgages: {
      clients: [],
      agentUsername: "",
      numberOfDays: 180,
      status: null
    },
    activities: {
      clients: [],
      numberOfDays: 30,
      expired: false
    },
    birthdays: {
      clients: [],
      agentUsername: "",
      numberOfDays: 30
    }
  },
  clientActivity: {
    byId: {},
    allIds: []
  },
  d2lSubmissions: [],
  charts: {
    appsReceived: [],
    closes: {
      currentMonth: [],
      previousMonth: []
    },
    applications: {
      completed: [],
      inProgress: []
    }
  }
};
export default state;